import { useState, useEffect, useCallback } from 'react';
import type { RiderDeductionInfo } from '../types/riderInfoDetail.types';
import { riderInfoDetailApi } from '../api/riderInfoDetailApi';
import { formatBirthDate } from '@/shared/utils/formatter';

type DeductionRawItem = {
    seqNo?: number;
    deductSeqNo?: number;
    deductName?: string;
    deductType?: string;
    calcType?: string;
    deductAmt?: number;
    startDay?: string;
    endDay?: string;
    startDate?: string;
    endDate?: string;
};

export const useRiderDeductions = (riderId?: string, suppId?: string) => {
    const [deductions, setDeductions] = useState<RiderDeductionInfo[]>([]);

    const fetchDeductions = useCallback(async () => {
        if (!riderId || !suppId) return;
        try {
            const deductionsData = await riderInfoDetailApi.getRiderDeductions(riderId, suppId);
            if (!deductionsData) return;

            let dataArray: DeductionRawItem[] = [];
            if (typeof deductionsData === 'object' && 'deductions' in deductionsData) {
                dataArray = deductionsData.deductions || [];
            } else if (Array.isArray(deductionsData)) {
                dataArray = deductionsData;
            } else if (typeof deductionsData === 'object') {
                dataArray = [deductionsData as DeductionRawItem];
            }

            setDeductions(
                dataArray.map((item, index) => ({
                    id: item.seqNo || item.deductSeqNo || index + 1,
                    name: item.deductName || '',
                    type: item.deductType || '',
                    calcType: item.calcType || '1',
                    amount: item.deductAmt || 0,
                    startDate: formatBirthDate(item.startDay || item.startDate || ''),
                    endDate: formatBirthDate(item.endDay || item.endDate || ''),
                })),
            );
        } catch {
            setDeductions([]);
        }
    }, [riderId, suppId]);

    useEffect(() => {
        if (suppId) fetchDeductions();
    }, [suppId, fetchDeductions]);

    return { deductions, fetchDeductions };
};
